import { LOCAL_STORAGE_KEYS } from './constants';
import { LastClickedSymbol, UserBook, SelectedMarketWatch, Widget } from '../app.interfaces';
import { ClientMessagesStorageInterface, UserInfo, RestUserInfo, ActiveTab, SortStateInterface, LastSubTabClicked } from 'sharedweb/app.interface';

export class StorageHelper {

    constructor() { }

    get(key: string) {
        if (localStorage.getItem(key)) {
            return JSON.parse(localStorage.getItem(key));
        }
    }

    set(key: string, value: any) {
        localStorage.setItem(key, JSON.stringify(value));
    }

    get userInfo(): UserInfo {
        return this.get(LOCAL_STORAGE_KEYS.userInfo);
    }
    set userInfo(userInfo: UserInfo) {
        this.set(LOCAL_STORAGE_KEYS.userInfo, userInfo);
    }

    set lastSubTabClicked(lastSubTabClicked: LastSubTabClicked) {
        this.set(LOCAL_STORAGE_KEYS.lastSubTabClicked, lastSubTabClicked);
    }

    get lastSubTabClicked(): LastSubTabClicked {
        return this.get(LOCAL_STORAGE_KEYS.lastSubTabClicked);
    }

    get whatsNewId(): number {
        return this.get(LOCAL_STORAGE_KEYS.whatsNewId);
    }

    set whatsNewId(whatsNewId: number) {
        this.set(LOCAL_STORAGE_KEYS.whatsNewId, whatsNewId);
    }

    get restUserInfo(): RestUserInfo {
        return this.get(LOCAL_STORAGE_KEYS.restUserInfo);
    }
    set restUserInfo(restUserInfo: RestUserInfo) {
        this.set(LOCAL_STORAGE_KEYS.restUserInfo, restUserInfo);
    }

    get userBook(): UserBook {
        return this.get(LOCAL_STORAGE_KEYS.userBook);
    }
    set userBook(userBook: UserBook) {
        this.set(LOCAL_STORAGE_KEYS.userBook, userBook);
    }

    get activeTab(): ActiveTab {
        return this.get(LOCAL_STORAGE_KEYS.activeTab);
    }
    set activeTab(activeTab: ActiveTab) {
        this.set(LOCAL_STORAGE_KEYS.activeTab, activeTab);
    }

    get selectedMarketWatch(): SelectedMarketWatch {
        return this.get(LOCAL_STORAGE_KEYS.selectedMarketWatch);
    }
    set selectedMarketWatch(selectedMarketWatch: SelectedMarketWatch) {
        this.set(LOCAL_STORAGE_KEYS.selectedMarketWatch, selectedMarketWatch);
    }

    get selectedMarketWatchId(): string {
        return this.get(LOCAL_STORAGE_KEYS.selectedMarketWatchId);
    }
    set selectedMarketWatchId(selectedMarketWatchId: string) {
        this.set(LOCAL_STORAGE_KEYS.selectedMarketWatchId, selectedMarketWatchId);
    }

    get widget(): Widget {
        return this.get(LOCAL_STORAGE_KEYS.widget);
    }
    set widget(widget: Widget) {
        this.set(LOCAL_STORAGE_KEYS.widget, widget);
    }


    get defaultMarketWatch(): number {
        return this.get(LOCAL_STORAGE_KEYS.defaultMarketWatch);
    }
    set defaultMarketWatch(defaultMarketWatch: number) {
        this.set(LOCAL_STORAGE_KEYS.defaultMarketWatch, defaultMarketWatch);
    }


    get lastClickedSymbol(): LastClickedSymbol {
        return this.get(LOCAL_STORAGE_KEYS.lastClickedSymbol);
    }

    set lastClickedSymbol(lastClickedSymbol: LastClickedSymbol) {
        this.set(LOCAL_STORAGE_KEYS.lastClickedSymbol, lastClickedSymbol);
    }

    get logMessages(): ClientMessagesStorageInterface {
        return this.get(LOCAL_STORAGE_KEYS.messages);
    }

    set logMessages(messagesData: ClientMessagesStorageInterface) {
        this.set(LOCAL_STORAGE_KEYS.messages, messagesData);
    }

    get themeSelected(): string {
        return this.get(LOCAL_STORAGE_KEYS.themeSelected);
    }

    set themeSelected(theme: string) {
        this.set(LOCAL_STORAGE_KEYS.themeSelected, theme);
    }

    get defaultProduct() {
        return this.get(LOCAL_STORAGE_KEYS.defaultProduct);
    }

    set defaultProduct(data) {
        this.set(LOCAL_STORAGE_KEYS.defaultProduct, data);
    }

    get deviceId() {
        return this.get(LOCAL_STORAGE_KEYS.deviceId);
    }

    set deviceId(data) {
        this.set(LOCAL_STORAGE_KEYS.deviceId, data);
    }

    get popupAccepted() {
        return this.get(LOCAL_STORAGE_KEYS.popupAccepted);
    }

    set popupAccepted(require: boolean) {
        this.set(LOCAL_STORAGE_KEYS.popupAccepted, require);
    }

    get nominationPopupAccepted() {
        return this.get(LOCAL_STORAGE_KEYS.nominationPopupAccepted);
    }

    set nominationPopupAccepted(require: boolean) {
        this.set(LOCAL_STORAGE_KEYS.nominationPopupAccepted, require);
    }

    set deltaValue(value: number) {
        this.set(LOCAL_STORAGE_KEYS.deltaValue, value);
    }

    get deltaValue(): number {
        return this.get(LOCAL_STORAGE_KEYS.deltaValue);
    }

    get lastLoggedInUser() {
        return this.get(LOCAL_STORAGE_KEYS.lastLoggedInUser);
    }

    set lastLoggedInUser(userId: string) {
        this.set(LOCAL_STORAGE_KEYS.lastLoggedInUser, userId);
    }

    get tradingViewInterval() {
        return this.get(LOCAL_STORAGE_KEYS.tradingViewInterval);
    }

    set tradingViewInterval(interval: string) {
        this.set(LOCAL_STORAGE_KEYS.tradingViewInterval, interval);
    }

    clearLastLoggedInUser() {
        localStorage.removeItem(LOCAL_STORAGE_KEYS.lastLoggedInUser);
    }

    clearActiveTab() {
        localStorage.removeItem(LOCAL_STORAGE_KEYS.activeTab);
    }

    clear() {
        localStorage.removeItem(LOCAL_STORAGE_KEYS.userInfo);
        localStorage.removeItem(LOCAL_STORAGE_KEYS.lastClickedSymbol);
        localStorage.removeItem(LOCAL_STORAGE_KEYS.selectedMarketWatch);
        localStorage.removeItem(LOCAL_STORAGE_KEYS.defaultProduct);
        localStorage.removeItem(LOCAL_STORAGE_KEYS.popupAccepted);
        localStorage.removeItem(LOCAL_STORAGE_KEYS.nominationPopupAccepted);
        localStorage.removeItem(LOCAL_STORAGE_KEYS.deltaValue);
        localStorage.removeItem(LOCAL_STORAGE_KEYS.tradingViewInterval);
        localStorage.removeItem(LOCAL_STORAGE_KEYS.activeTab);
        localStorage.removeItem(LOCAL_STORAGE_KEYS.lastSubTabClicked);
    }
}
